export const API_BASE =
  process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : '/api';

export function uploadUrl(filename) {
  return filename ? `${API_BASE}/uploads/${filename}` : '';
}

function authHeaders() {
  const token = localStorage.getItem('admin_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

async function handleResponse(res) {
  if (res.status === 401) {
    localStorage.removeItem('admin_token');
    window.location.href = '/admin/login';
    return;
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.detail || '요청에 실패했습니다.');
  return data;
}

async function request(method, path, body) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  return handleResponse(res);
}

async function uploadFile(path, file) {
  const formData = new FormData();
  formData.append('file', file);
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { ...authHeaders() },
    body: formData,
  });
  return handleResponse(res);
}

export const api = {
  // auth
  login: (username, password) =>
    request('POST', '/auth/login', { username, password }),

  // performances
  getPerformances: () => request('GET', '/performances'),
  createPerformance: (data) => request('POST', '/performances', data),
  updatePerformance: (id, data) => request('PUT', `/performances/${id}`, data),
  deletePerformance: (id) => request('DELETE', `/performances/${id}`),

  // clients
  getClients: () => request('GET', '/clients'),
  createClient: (data) => request('POST', '/clients', data),
  updateClient: (id, data) => request('PUT', `/clients/${id}`, data),
  deleteClient: (id) => request('DELETE', `/clients/${id}`),
  uploadClientLogo: (file) => uploadFile('/clients/upload-logo', file),

  // notices
  getNotices: () => request('GET', '/notices'),
  getAllNotices: () => request('GET', '/notices/all'),
  createNotice: (data) => request('POST', '/notices', data),
  updateNotice: (id, data) => request('PUT', `/notices/${id}`, data),
  deleteNotice: (id) => request('DELETE', `/notices/${id}`),

  // inquiries
  createInquiry: (data) => request('POST', '/inquiries', data),
  getInquiries: () => request('GET', '/inquiries'),
  updateInquiryStatus: (id, status) =>
    request('PUT', `/inquiries/${id}/status`, { status }),
  deleteInquiry: (id) => request('DELETE', `/inquiries/${id}`),
  getInquiryStats: () => request('GET', '/inquiries/stats'),
};
